import React from 'react'

const LoadingSpinner = ({size}) => {
  return (
    <div className={`animate-spin rounded-full ${size == "sm" ? "h-5 w-5": "h-8 w-8"} border-b-2 border-blue-600`}></div>
  )
}

export default LoadingSpinner